var exports = {
  "oO": "popover__G1OTU9",
  "Vg": "grid__CK7N63",
  "Pf": "label__w1qyRr",
  "Uq": "value__aK3I4E",
};

module.exports = exports;
